import { toast } from "sonner";
import { AuthAPI } from "@/lib/api";
import { openSnap } from "@/lib/midtrans";

// Bayar biaya pendaftaran (pokok + wajib bulan pertama) lewat Midtrans untuk akun yang belum aktif.
// `payment` = { status, token, ref } dari respons daftar / login. Menampilkan toast hasilnya dan
// mengembalikan "PAID" | "PENDING" | "FAILED" | "CLOSED".
export async function payRegistration(payment) {
  if (payment?.status === "PAID") {
    toast.success("Pembayaran pendaftaran sudah diterima. Akun aktif setelah data diverifikasi Kantor Ranting.");
    return "PAID";
  }
  if (!payment?.token) throw new Error("Tagihan pembayaran tidak tersedia");

  const result = await openSnap(payment.token);
  const latest = await AuthAPI.registrationPayment(payment.ref).catch(() => null);
  if (latest?.status === "PAID") {
    toast.success("Pembayaran pendaftaran berhasil. Akun aktif setelah data diverifikasi Kantor Ranting.", { duration: 8000 });
    return "PAID";
  }
  if (latest?.midtrans_status === "pending" || result === "pending") {
    toast.info("Selesaikan pembayaran sesuai instruksi (mis. Virtual Account). Status diperbarui otomatis.", { duration: 8000 });
    return "PENDING";
  }
  if (result === "error") {
    toast.error("Pembayaran gagal. Coba lagi dengan masuk ke akun Anda.");
    return "FAILED";
  }
  toast.info("Pembayaran belum selesai. Anda bisa melanjutkannya dengan masuk ke akun Anda.", { duration: 8000 });
  return "CLOSED";
}
